import { FlatObject } from '../types/appTypes';

export type Product = {
  id: 'sport' | 'casino' | 'liveCasino' | 'virtualSports';
  route: string;
};

// local storage
export const LOGIN_TIME = 'LOGIN_TIME';

export const ROUTES: FlatObject = {
  bet_history: 'sport#bethistory',
  bonus_offers: 'sport/other-sport-bonuses#bonus-offers',
  bonus: 'bonus',
  casino: 'casino-games',
  casinoGame: 'casino-game',
  completedCasinoBonus: 'completed-bonus',
  deposit: '/account/deposit',
  history: 'history',
  info: 'info',
  landing: 'landing',
  limits: 'limits',
  liveCasino: 'live-casino',
  liveCasinoGame: 'live-casino-game',
  login: 'login',
  paymentLoader: 'payment',
  paymentVerification: 'payment/verify',
  verifyAccount: '/verify',
  activate: '/account/activate',
  verifyEmail: '/account/verify-email',
  profile: '/account/profile',
  register: 'register',
  sport: 'sport',
  sportsAZ: 'all-sports',
  withdraw: '/account/withdraw',
  virtualSports: 'virtual-sports',
  virtualSport: 'virtual-sport',
  accountVerification: 'account-verification',
};

export enum PRODUCT_TYPES {
  sport = 'Sport',
  casino = 'Casino',
  live_Casino = 'Live Casino',
  virtual_sports = 'Virtual Sports',
}

export const productRoutes: Array<Product> = [
  { id: 'sport', route: ROUTES.sport },
  { id: 'casino', route: ROUTES.casino },
  { id: 'liveCasino', route: ROUTES.liveCasino },
  { id: 'virtualSports', route: ROUTES.virtualSports },
];

export enum TRANSACTION_TYPES {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}

export const REALITY_CHECK_TIME = 'REALITY_CHECK_TIME';
export const REALITY_CHECK_BALANCE = 'REALITY_CHECK_NUMBER';
export const PAYMENT_WINDOW = 'PAYMENT_WINDOW';

export const EMAIL_KEY = 'MybetEmail';
export const REGISTRATION_REDIRECT = 'REGISTRATION_REDIRECT';

// Hard codded list of languages that the App supports
export const APP_LANGUAGES = ['de', 'en'];
// Full language code for Kambi client
export const LANGUAGE_CODES = {
  en: 'en_GB',
  de: 'de_DE',
};
export const SELECTED_LANGUAGE = 'selectedLanguage';

export enum PAGES {
  live = 'live',
  today = 'today',
  tomorrow = 'tomorrow',
  sports = 'sports',
  home = 'home',
  betHistory = 'bethistory',
  sport = 'sport',
  event = 'event',
  allMatches = 'allMatches',
  league = 'league',
  casino = 'casino',
  casinoHome = 'casino-games',
  liveCasinoHome = 'live-casino',
  sportBonus = 'bonus-offers',
  landing = 'landing',
  bonus = 'bonus',
  virtualSports = 'virtual-sports',
  sportBonuses = 'other-sport-bonuses',
}

export enum LOCALISATION_NAMESPACES {
  common = 'common',
  'limits_page' = 'limits_page',
  'password_reset' = 'password_reset',
  bonus = 'bonus',
  widgets = 'widgets',
}

export const CUSTOM_SPORTTABS: FlatObject = {
  boosts___specials: 'boosts___specials',
};

export enum betRadarWidgets {
  lmtPlus = 'match.lmtPlus',
  lmtSticky = 'match.lmtSticky',
  liveTable = 'season.liveTable',
  fixtures = 'season.fixtures',
}

export const COOKIES_POLICY = '_cookiesPolicy';
export const USER_COUNTRY = '_userCountry';
export const TEN_YEARS = 10 * 365 * 24 * 60 * 60;

export const HIDE_CASINO_BONUS_MODAL = 'hideCasinoBonusModal';
export const FREE_ROUND_BONUS = 'freeround';

export const SHOW_BALANCE = 'show_balance';

export const WITHDRAW_ONLY = 'Withdraw only';
export const WITHDRAW_BLOCK = 'Withdraw block';
export const VERIFIED_IDENTITY = 'Verified Identity';

export const AFFILIATE_TAG = 'affTag';
export enum AFFILIATE_TYPES {
  DV = 'DV',
  CPM = 'CPM',
  AF = 'AF',
}

export const DATA_LAYER_NAME = 'dataLayer';

export const KAMBI_LIVE_INTERVAL = 20000; // 20 seconds

export enum PIXEL_TRACK_GOAL {
  registration = 1,
  deposit,
  placeBet,
}

export enum GA_CATEGORIES {
  cashOut = 'Cash Out',
  registration = 'RegilyJoin',
  deposit = 'Deposit',
  betting = 'Betting',
  navigation = 'Navigation',
  user = 'User',
  userProfile = 'User profile',
  search = 'Search',
  withdraw = 'Withdraw',
  internalPromotions = 'Internal promotions',
  ecommerce = 'Ecommerce',
}

export enum GTM_EVENTS {
  ga = 'GA',
  pageView = 'PageView',
  mybetEventListClick = 'MybetEventListClick',
}

export const DEFAULT_COUNTRY = 'DE';
export const DEFAULT_MARKET = 'mybetde';
export const TAX_FREE_MARKET = 'mybet';
export const TAX_FREE_COUNTRIES: Array<string> = [
  'AT', // Austria
  'LI', // Liechtenstein
  'LU', // Luxembourg
];

export const DOMAINS = ['mybet.com', 'mybet.de'];

export enum BANNER_DISPLAY_TYPES {
  NRC = 'NRC',
  NTD = 'NTD',
  ALL = 'ALL',
}

// GRID TYPES (currently used to generate grid template area for casino)
export const GRID_TEMPLATES = {
  s6: {
    items: ['s1', 's2', 's3', 's4', 's5', 's6'],
    templateArea: ['s1 s2 s3 s4 s5 s6'],
  },
  q1dh1s6: {
    items: ['q1', 's1', 's2', 's3', 's4', 'dh1', 's5', 's6'],
    templateArea: ['q1 q1 s1 s2 dh1 dh1', 'q1 q1 s3 s4 s5 s6'],
  },
  dh1dv1s8: {
    items: ['dh1', 's1', 's2', 's3', 's4', 's5', 's6', 'dv1', 's7', 's8'],
    templateArea: ['dh1 dh1 s3 s4 dv1 s7', 's1 s2 s5 s6 dv1 s8'],
  },
  dv1dh1s8: {
    items: ['dv1', 's1', 's2', 's3', 's4', 's5', 's6', 'dh1', 's7', 's8'],
    templateArea: ['dv1 s1 s3 s5 dh1 dh1', 'dv1 s2 s4 s6 s7 s8'],
  },
  dv6: {
    items: ['dv1', 'dv2', 'dv3', 'dv4', 'dv5', 'dv6'],
    templateArea: ['dv1 dv2 dv3 dv4 dv5 dv6', 'dv1 dv2 dv3 dv4 dv5 dv6'],
  },
  q1s8: {
    items: ['q1', 's1', 's2', 's3', 's4', 's5', 's6', 's7', 's8'],
    templateArea: ['q1 q1 s1 s3 s5 s7', 'q1 q1 s2 s4 s6 s8'],
  },
  s4q1s4: {
    items: ['s1', 's2', 's3', 's4', 'q1', 's5', 's6', 's7', 's8'],
    templateArea: ['s1 s3 q1 q1 s5 s7', 's2 s4 q1 q1 s6 s8'],
  },
  s8q1: {
    items: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 'q1'],
    templateArea: ['s1 s3 s5 s7 q1 q1', 's2 s4 s6 s8 q1 q1'],
  },
};

export enum CasinoTypes {
  casino,
  live,
  virtual,
}

export enum UserSource {
  direct = 'Direct',
  email = 'Mail',
}

export const VerticalTypes: FlatObject = {
  live: 'live-casino',
  casino: 'casino-games',
  virtual: 'virtual-sport',
};
